require('./insuranceRequestWizardStep3.scss');
require('./insuranceRequestWizardStep3.override.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ utils
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @ constants
const { EVENTS_INSURANCE_HOME } = require('../../../insuranceConstants/insuranceRequestTags');
const { EURO_SYMBOL, SECOND_STEP, THIRD_STEP, FOURTH_STEP } = require('constants/index');
const { PLANS: { BASIC }, PROPERTY_USAGE: { RENT }, NA } = require('../../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_USABILITY_IMPROVEMENTS,
    INSURANCE_EXTRA_SERVICE,
} = require('constants/flagBasedFeatures');

// @ commonsComponents
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');

// @ components
const InsuranceRequestPlans = require('../../insuranceRequestPlans/insuranceRequestPlans');
const InsuranceRequestWizardStep3Tooltips = require('./insuranceWizardStep3Components/insuranceRequestWizardStep3Tooltips');
const InsuranceRequestWizardStep3PlanModal = require('./insuranceWizardStep3Components/insuranceRequestWizardStep3PlanModal');
const InsuranceRequestBuildPaymentType = require('../insuraceRequestBuildPaymentType/insuranceRequetsBuildPaymentType');
const InsuranceRequestWizardGDPRMessage = require('../insuranceRequestWizardGDPRMessage/insuranceRequestWizardGDPRMessage');

class InsuranceRequestWizardStep3 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            resetPlan: false,
        };

        this.onhandlePaymentTypeChange = this.onhandlePaymentTypeChange.bind(this);
        this.onhandleAccountChange = this.onhandleAccountChange.bind(this);
        this.handleTooltipMouseOver = this.handleTooltipMouseOver.bind(this);
        this.handleTooltipMouseOut = this.handleTooltipMouseOut.bind(this);
        this.recordEventSelectPlan = this.recordEventSelectPlan.bind(this);
        this.onHandleModalClose = this.onHandleModalClose.bind(this);
        this.handleInsurancePlanModal = this.handleInsurancePlanModal.bind(this);
    }

    componentWillMount() {
        const {
            getCoveragesAndPlansData,
            getQuotationData,
            getCoveragesAndPlansDetailsData,
            immInsuranceWizard,
            hasSimulationChanged,
            isRnc,
            setData
        } = this.props;
        const immInsuranceWizardStep2 = immInsuranceWizard.getIn(['steps', SECOND_STEP]);
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const step3LoadingFromDetailsTable = immInsuranceWizardStep3.get('step3LoadingFromDetailsTable')
        const propertyUsage = immInsuranceWizardStep2.get('propertyUsage');
        const propertyCharacter = immInsuranceWizardStep2.get('propertyCharacter');
        setData(THIRD_STEP, { basicPlanModalValidation: false });

        if (isRnc && hasSimulationChanged) {
            this.setState({ resetPlan: true })
        }

        if (step3LoadingFromDetailsTable) {
            setData(THIRD_STEP, { step3LoadingFromDetailsTable: false });
        } else {
            getQuotationData(hasSimulationChanged);
            getCoveragesAndPlansData(propertyUsage);
            getCoveragesAndPlansDetailsData(propertyUsage, propertyCharacter);
        }
    }

    componentWillUnmount() {
        const { linkClientSuccessInitialState } = this.props
        linkClientSuccessInitialState();
    }

    handleTooltipMouseOver(link) {
        this.tooltipHover = setTimeout(() => {
            this.props.recordEvent(EVENTS_INSURANCE_HOME.STEP_3_LINKS_HOVER, link);
        }, 2000);
    }

    handleTooltipMouseOut() {
        // this.tooltipHover.close && clearTimeout(this.tooltipHover);
        clearTimeout(this.tooltipHover);
    }

    onhandlePaymentTypeChange(paymentType = '') {
        const { setData, immInsuranceState, immInsuranceWizard } = this.props;

        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);

        const plan = immInsuranceState.getIn(['data', 'insurancePlan']);
        const planLowerCase = plan && plan.toLowerCase()
        const totalCost = immInsuranceWizardStep3.getIn(['pricing', paymentType.toLowerCase(), planLowerCase, 'firstImport']);

        setData(THIRD_STEP, {
            paymentType,
            totalCost
        });
        this.setState({ resetPlan: false })
    }

    onhandleAccountChange(accountId) {
        const {
            immAccounts,
            setData
        } = this.props;

        if (!!accountId) {
            const immAccount = immAccounts.getIn(['byId', accountId]);
            setData(THIRD_STEP, {
                accountId,
                accountBalance: immAccount.getIn(['balance', 'amount']),
                accountIBAN: immAccount.get('iban')
            });
        }
    }

    buildRncPaymentTypeAndMessage() {
        const {
            immInsuranceState,
            immInsuranceWizard,
            isRelated,
            isRnc,
        } = this.props

        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const paymentSelected = immInsuranceWizardStep3.get('paymentType');
        const insurancePlan = immInsuranceWizardStep3.get('insurancePlan');
        const MessageContainer = __CONTACT_CENTER__ ? BlockInfo : OKMessage;

        if (!insurancePlan) return null;

        return (
            <div className="col-xs-12">
                <div className="insurance-request-wizard-step-three__field-errors-message">
                    <InsuranceRequestBuildPaymentType
                        isRnc={isRnc}
                        paymentSelected={paymentSelected}
                        immInsuranceState={immInsuranceState}
                        immInsuranceWizardStep={immInsuranceWizardStep3}
                        isRelated={isRelated}
                        onhandlePaymentTypeChange={this.onhandlePaymentTypeChange}
                        onhandleAccountChange={this.onhandleAccountChange}
                        resetPlan={this.state.resetPlan}
                    />
                    <MessageContainer>
                        <FormattedText value="mortgageRequestInsuranceRnc-step3PaymentDisclaimer" />
                    </MessageContainer>
                </div>
                <div className="insurance-request-wizard-step-three__gdpr-message">
                    <InsuranceRequestWizardGDPRMessage />
                </div>
            </div>
        );
    }

    recordEventSelectPlan(plan) {
        this.props.recordEvent(EVENTS_INSURANCE_HOME.STEP_3_SELECT_PLAN_CLICK, plan);
    }

    onHandleModalClose() {
        const { setData } = this.props;
        setData(THIRD_STEP, { basicPlanModalValidation: false });
    }

    handleInsurancePlanModal(immInsuranceWizardStep3) {
        const { validateStep } = this.props;
        const associatingClient = immInsuranceWizardStep3.get('isFetchingSelectPlan') || immInsuranceWizardStep3.get('isLinkingInProgress');
        const basicPlanModalValidation = immInsuranceWizardStep3.get('basicPlanModalValidation');

        return (
            <InsuranceRequestWizardStep3PlanModal
                handleRequestClose={this.onHandleModalClose}
                isOpen={basicPlanModalValidation}
                loading={associatingClient}
                onRequestAccept={() => validateStep(FOURTH_STEP, true)}
            />
        );
    }

    buildLegalBoxInfo() {
        let {
            immFlagBasedFeatures,
            isRelated,
            isPostAppraisal
        } = this.props;

        return !immFlagBasedFeatures.get(INSURANCE_EXTRA_SERVICE) && (
            <div className="row">
                <div className="col-sm-12 insurance-request-wizard-step-three__box-info">
                    <InsuranceRequestWizardStep3Tooltips
                        isRelated={isRelated}
                        isPostAppraisal={isPostAppraisal}
                        onHandleTooltipMouseOver={this.handleTooltipMouseOver}
                        onHandleTooltipMouseOut={this.handleTooltipMouseOut}
                    />
                </div>
            </div>
        );
    }

    render() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            insuranceSelectPlan,
            onChangeShowCoverageDetailTable,
            isRelated,
            selectPlanInRelatedWizardStep3,
            onhandleChangeSelectedPlanInStateComponent,
            isPostAppraisal,
            setData,
            isRnc,
            requestInsuranceRelatedRNCCurrentPricing
        } = this.props;

        const insuranceUsabilityImprovementsFlag = !!immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const immInsuranceWizardStep2 = immInsuranceWizard.getIn(['steps', SECOND_STEP]);
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const fetchingQuotationData = immInsuranceWizardStep3.get('isFetchingQuotation');
        const fetchingCoveragesData = immInsuranceWizardStep3.get('isFetchingCoverages');
        const coveragesAndPlansSize = immInsuranceWizardStep3.get('coveragesAndPlansData').size === 0;
        const coveragesDetailsMedium = immInsuranceWizardStep3.get('isFetchingDetailsMedium');
        const coverageDetailsBasic = immInsuranceWizardStep3.get('isFetchingDetailsBasic');
        const coverageDetailsHigh = immInsuranceWizardStep3.get('isFetchingDetailsHigh');
        const fetchingCoveragesDetails = coveragesDetailsMedium || coverageDetailsBasic || coverageDetailsHigh;

        if (fetchingQuotationData || fetchingCoveragesData || coveragesAndPlansSize || fetchingCoveragesDetails) {
            return <LoadingSection />;
        }

        const valueToEnsure = formatText('insuranceRequestHome-step3ValuesToEnsure');
        const step3Title = formatText('insuranceRequestHome-step3InsurancesOptionsTitle');
        const contentTitle = formatText('insuranceRequestHome-step3InsuranceContent');
        const continentTitle = formatText('insuranceRequestHome-step3InsuranceContinent');
        const language = getLanguage();
        const contentValue = formatAmount(immInsuranceWizardStep2.get("content"), language, 0);
        const continentValue = formatAmount(immInsuranceWizardStep2.get("continent"), language, 0);

        const showErrorMessage = immInsuranceWizardStep3.get('fieldErrors') && !immInsuranceWizardStep3.get('insurancePlan')
        const errorMessage = showErrorMessage && (
            <div className="col-xs-12 insurance-request-wizard-step-three__field-errors-message">
                <OKMessage type="warning">
                    <FormattedText value="insuranceRequestHome-step3ValidationError" />
                </OKMessage>
            </div>
        );

        let insurancePlan = '';
        let propertyUsage = '';
        let isUsagePropertyRentAndBasicPlan;
        if (!isRelated) {
            insurancePlan = immInsuranceWizardStep3.get("insurancePlan");
            propertyUsage = immInsuranceWizardStep2.get("propertyUsage");
            isUsagePropertyRentAndBasicPlan = insurancePlan === BASIC && propertyUsage === RENT
        }

        return (
            <div className="row insurance-request-wizard-step-three">
                <header className="insurance-request-wizard-step-three__step-title">{step3Title}</header>
                {errorMessage}
                <div className="col-xs-12 insurance-request-wizard-step-three__box-info">
                    <div className="insurance-request-wizard-step-three__box-info-content">
                        <span className="insurance-request-wizard-step-three__box-info-text-bold">{valueToEnsure}</span>
                        <span className="insurance-request-wizard-step-three__box-info-text">
                            <i className="icon-continente insurance-request-wizard-step-three__icon"></i>
                            {continentTitle}
                            <span className="insurance-request-wizard-step-three__box-info-text-bold">
                                {`${continentValue} ${EURO_SYMBOL}`}
                            </span>
                        </span>
                        <span className="insurance-request-wizard-step-three__box-info-text">
                            <i className="icon-contenido insurance-request-wizard-step-three__icon"></i>
                            {contentTitle}
                            <span className="insurance-request-wizard-step-three__box-info-text-bold">
                                {isUsagePropertyRentAndBasicPlan ? NA : `${contentValue} ${EURO_SYMBOL}`}
                            </span>
                        </span>
                    </div>
                </div>

                <div className="col-sm-12">
                    <InsuranceRequestPlans
                        isRelated={isRelated}
                        isRnc={isRnc}
                        selectPlanInRelatedWizardStep3={selectPlanInRelatedWizardStep3}
                        onChangeShowCoverageDetailTable={onChangeShowCoverageDetailTable}
                        insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                        immInsuranceState={immInsuranceState}
                        immInsuranceWizardStep={immInsuranceWizardStep3}
                        propertyInformation={immInsuranceWizardStep2}
                        insuranceSelectPlan={insuranceSelectPlan}
                        onhandleChangeSelectedPlanInStateComponent={onhandleChangeSelectedPlanInStateComponent}
                        setData={setData}
                        requestInsuranceRelatedRNCCurrentPricing={requestInsuranceRelatedRNCCurrentPricing}
                        recordEventSelectPlan={this.recordEventSelectPlan}
                        isPostAppraisal={isPostAppraisal}
                    />
                </div>
                {
                    isUsagePropertyRentAndBasicPlan &&
                    (
                        <div className="insurance-request-wizard-step-three__messagge-container col-sm-12">
                            <div className="insurance-request-wizard-step-three__messagge">
                                <OKMessage
                                    visible
                                    type="informative"
                                >
                                    <div className="insurance-request-wizard-step-three__disclaimer-text">
                                        <FormattedText value="insuranceRequestHome-step3InformativeDisclaimer" />
                                    </div>
                                </OKMessage>
                            </div>
                        </div>
                    )
                }
                {this.buildLegalBoxInfo()}
                {isRnc && isPostAppraisal && this.buildRncPaymentTypeAndMessage()}
                {insuranceUsabilityImprovementsFlag && this.handleInsurancePlanModal(immInsuranceWizardStep3)}
            </div>
        )
    }
}

InsuranceRequestWizardStep3.propTypes = {
    getCoveragesAndPlansData: PropTypes.func.isRequired,
    getCoveragesAndPlansDetailsData: PropTypes.func.isRequired,
    getQuotationData: PropTypes.func.isRequired,
    hasSimulationChanged: PropTypes.bool.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizard: PropTypes.object.isRequired,
    insuranceSelectPlan: PropTypes.func.isRequired,
    isPostAppraisal: PropTypes.bool,
    isRelated: PropTypes.bool,
    isRnc: PropTypes.bool,
    linkClientSuccessInitialState: PropTypes.func,
    onChangeShowCoverageDetailTable: PropTypes.func.isRequired,
    onhandleChangeSelectedPlanInStateComponent: PropTypes.func,
    recordEvent: PropTypes.func.isRequired,
    requestInsuranceRelatedRNCCurrentPricing: PropTypes.func,
    selectPlanInRelatedWizardStep3: PropTypes.func,
    setData: PropTypes.func.isRequired,
    validateStep: PropTypes.func,
};

InsuranceRequestWizardStep3.defaultProps = {
    isRelated: false,
    isRnc: false,
    isPostAppraisal: false,
    selectPlanInRelatedWizardStep3: () => { },
    onhandleChangeSelectedPlanInStateComponent: () => { },
    linkClientSuccessInitialState: () => { },
    requestInsuranceRelatedRNCCurrentPricing: () => { },
};

module.exports = InsuranceRequestWizardStep3;
